export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9214.ad627627.jpg";